export interface EnrollmentStatusEntity {
  enrollmentId: string;
  status: string;
  updatedAt: string;
}

export interface PersonValidationEntity {
  userId: string;
  merchantIdScanReference?: string;
  selfieRaw: string;
  templateRaw?: string;
  selfie: string;
}

export const BIOMETRIC_ENROLMENT_STATUS = {
  COMPLETED: 'COMPLETED',
  BLOCKED: 'BLOCKED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  AUTHORIZED: 'AUTHORIZED',
  PERSON_VALIDATION_FAILED: 'PERSON_VALIDATION_FAILED',
  LIVENESS_CHECK_SUCCESS: 'LIVENESS_CHECK_SUCCESS',
  DOCUMENT_OBTAINED_FROM_DNIC: 'DOCUMENT_OBTAINED_FROM_DNIC',
}